import { AppThunk } from '../../../../store/types';
import { Navigator } from '../../../../effects/navigator';
import { getAuthUser } from '../../../../store/general/selectors';
import { AuthManager } from '../../../../../common/utils/auth-manager';
import { restoreAppSettings } from '../../../../effects/prepareAfterOpen';
import { setAuthUserAction } from '../../../../store/general/actions';
import { updateUserLanguages } from '../../../../effects/updateUserLanguages';
import { updateUserGroups } from '../../../../effects/updateUserGroups';
import { PhraseDetailsTabEffects } from '../../../../effects/phraseDetailsTabEffects';
import { VideoTutorialEffects } from '../../../../effects/videoTutorialEffects';

export class UserSettingsEvents {

	public static onLoad(): AppThunk {
		return async (
			dispatch,
			getState
		): Promise<any> => {
			if (!getAuthUser(getState())) {
				const result = await AuthManager.autoLogin();
				if (result?.authUser) {
					restoreAppSettings(result.appSettings);
					dispatch(setAuthUserAction(result.authUser));
					dispatch(updateUserLanguages());
					dispatch(updateUserGroups(true));
					PhraseDetailsTabEffects.load();
					VideoTutorialEffects.loadList();
				} else {
					Navigator.openDefault();
				}
			}
		}
	}

	public static onClose(): AppThunk {
		return (
			dispatch,
			getState
		) => {
			if (window.onpopstate) {
				history.back();
			} else { // direct url
				Navigator.openDefault();
			}
		}
	}

}
